
import {  TabList as BaseTabsList, TabPanel as BaseTabPanel } from '@mui/lab';
import { Tab as BaseTab, } from '@mui/material';
import { styled } from '@mui/system';
import { blue, grey } from '@mui/material/colors';

export const styleIcon = {
    color: '#004F9F',
    fontSize: 20,
    marginRight: 10,
    cursor: 'pointer'
}

export const Tab = styled(BaseTab)`
    color: #fff;
    opacity: 1;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 600;
    background-color: transparent;
    width: 100%;
    min-height: 0px;
    padding: 10px 12px;
    margin: 6px;
    border: none;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    text-transform: none;

    &:hover {
        background-color: ${blue[800]};
    }

    &:focus {
        color: #fff;
    }

    &.Mui-selected {
        background-color: #fff;
        color: ${blue[900]};
    }
`;

export const TabPanel = styled(BaseTabPanel)(
    ({ theme }) => `
    width: 100%;
    padding: 0;
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    `,
);

export const TabList = styled(BaseTabsList)(
    ({ theme }) => `
    background-color: ${blue[900]};
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: space-between;
    box-shadow: 0px 4px 30px ${theme.palette.mode === 'dark' ? grey[900] : grey[200]};

    & .MuiTabs-indicator {
        display: none
    }
    `,
);